const getGooglePaySettings = ({
  transactionInfo,
  countryCode,
  adyenMerchantId,
}: {
  transactionInfo: google.payments.api.TransactionInfo;
  countryCode: string;
  adyenMerchantId: string;
}): google.payments.api.PaymentDataRequest => {
  if (!process.env.ADYEN_GATEWAY) {
    throw new Error("Adyen Gateway is not provided");
  }

  if (!adyenMerchantId) {
    throw new Error("Adyen Merchant Id is not provided");
  }

  if (!process.env.GOOGLE_PAY_MERCHANT_ID) {
    throw new Error("Google Pay Merchant Id is not provided");
  }

  return {
    apiVersion: 2,
    apiVersionMinor: 0,
    allowedPaymentMethods: [
      {
        type: "CARD",
        parameters: {
          allowedAuthMethods: ["PAN_ONLY", "CRYPTOGRAM_3DS"],
          allowedCardNetworks: ["VISA", "MASTERCARD", "AMEX"],
          billingAddressRequired: true,
          billingAddressParameters: {
            format: "FULL",
            phoneNumberRequired: true,
          },
        },
        tokenizationSpecification: {
          type: "PAYMENT_GATEWAY",
          parameters: {
            gateway: process.env.ADYEN_GATEWAY,
            gatewayMerchantId: adyenMerchantId,
          },
        },
      },
    ],
    merchantInfo: {
      merchantName: process.env.GOOGLE_PAY_MERCHANT_NAME,
      merchantId: process.env.GOOGLE_PAY_MERCHANT_ID,
    },
    shippingAddressRequired: true,
    shippingAddressParameters: {
      allowedCountryCodes: [countryCode],
      phoneNumberRequired: true,
    },
    emailRequired: true,
    transactionInfo,
  };
};

export default getGooglePaySettings;
